import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import user from './user'

Vue.use(Router)
const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/modules/home/_views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/modules/login/_views/Login.vue'),
    meta: { skipAuth: true }
  }
].concat(user, [{
  path: '/',
  redirect: '/login'
}])

const router = new Router({ routes })

router.beforeEach(async (to, from, next) => {
  if (!to.meta.skipAuth) {
    await store.dispatch('entities/users/fetchMe')
    if (store.getters['entities/users/isConnected'] === true) {
      next()
      return
    }
    next('/login')
    return
  }
  next()
})

export default router
